import { toast, Flip } from "react-toastify";

const SuccessfulSave = (message = "Changes saved") => {
  toast.success(message, {transition: Flip});
};

const NotFound = () => {
  toast.error("Not found", {transition: Flip});
};

const Error = (message) => {
  if(typeof message === "undefined") {
      message = "Error: Changes not saved";
  }
  toast.error(message, {transition: Flip});
};

const NotAllowed = (message) => {
  if(typeof message === "undefined") {
      message = "Error: This Action is not allowed";
  }
  toast.error(message, {transition: Flip});
};

const QuotaExceeded = (message) => {
  if (typeof message === "undefined") {
    message = "Monthly AI limit reached. Resets on the 1st of next month.";
  }
  toast.warning(message, { transition: Flip });
};

const ToastMessages = {SuccessfulSave, NotFound, Error, NotAllowed, QuotaExceeded};
export default ToastMessages;